import { action } from "@ember/object";
import { service } from "@ember/service";
import { scrollTop } from "discourse/lib/scroll-top";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CircleRoute extends DiscourseRoute {
  @service composer;
  @service currentUser;
  @service circles;
  @service currentCircle;
  @service dialog;
  @service router;

  beforeModel() {
    if (!this.circles.userCanUseCircles) {
      this.router.replaceWith("/404");
    }
  }

  model(params) {
    return this.store.find("circle", params.slug_path_with_id);
  }

  serialize(model) {
    return { name: model?.name?.toLowerCase() };
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    controller.set("model", model);
    controller.set("category", model.category);

    controller.setProperties({
      showCategoryAdmin: model.category.get("can_create_category"),
      canCreateTopic: model.category.get("can_create_topic"),
    });
  }

  @action
  didTransition() {
    scrollTop();
  }

  @action
  clickCreateTopicButton() {
    if (this.currentUser?.has_topic_draft) {
      this.composer.openNewTopic({ preferDraft: true });
    } else {
      this.#createNewTopic();
    }
  }

  #createNewTopic() {
    if (this.currentCircle.userCanCreateTopic) {
      this.composer.openNewTopic({
        category: this.controller.model?.category,
      });
    } else {
      if (this.currentCircle.userIsMember) {
        this.dialog.alert(
          i18n("discourse_circles.circle.errors.cant_create_topic")
        );
      } else {
        this.dialog.alert(
          i18n("discourse_circles.circle.errors.join_before_create_topic")
        );
      }
    }
  }
}
